import { editorOrAbovePolicy } from "./common";

/** ダッシュボード関連リソースのポリシー。 */
export const DASHBOARD_POLICIES = {
  /** ダッシュボードの作成や並び替え等の編集可否を判定します。 */
  "dashboard:edit": editorOrAbovePolicy,
} as const;
